import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FormValidation {
  public formatPhoneInput(
    e: KeyboardEvent,
    textValue: string,
    guidedFormat: string,
  ): string {
    if (e.code == 'Backspace') {
      let correspondingFormatChar = guidedFormat[textValue.length - 1];
      if (correspondingFormatChar == '-') {
        textValue = textValue.substring(0, textValue.length - 1);
      }
    } else if (textValue.length < guidedFormat.length) {
      let correspondingFormatChar = guidedFormat[textValue.length];
      if (correspondingFormatChar == '-') {
        textValue += '-';
      }
    } else if (textValue.length > guidedFormat.length) {
      // don't allow any more characters
      textValue = textValue.substring(0, guidedFormat.length);
    }
    return textValue;
  }

  public formatDateInput(
    e: KeyboardEvent,
    textValue: string,
    guidedFormat: string,
  ): string {
    if (e.code == 'Backspace') {
      let correspondingFormatChar = guidedFormat[textValue.length];
      if (correspondingFormatChar == '/') {
        textValue = textValue.substring(0, textValue.length - 1);
      }
    } else {
      if (textValue.length < guidedFormat.length) {
        let prevFormatChar = guidedFormat[textValue.length - 2];
        let thisFormatChar = guidedFormat[textValue.length - 1];
        let nextFormatChar = guidedFormat[textValue.length];

        if (prevFormatChar != 'm' && thisFormatChar == 'm') {
          // this is the first month char

          if (new RegExp(/[2-9]/g).test(e.key)) {
            textValue =
              textValue.substring(0, textValue.length - 1) + '0' + e.key + '/';
          } else if (!new RegExp(/[0-1]/g).test(e.key)) {
            textValue = textValue.substring(0, textValue.length - 1);
          }
        } else if (thisFormatChar == 'm') {
          // this is the second month char

          if (textValue[textValue.length - 2] == '0') {
            if (!new RegExp(/[1-9]/g).test(e.key)) {
              textValue = textValue.substring(0, textValue.length - 1);
            } else {
              textValue += '/';
            }
          } else {
            if (!new RegExp(/[0-2]/g).test(e.key)) {
              textValue = textValue.substring(0, textValue.length - 1);
            } else {
              textValue += '/';
            }
          }
        } else if (prevFormatChar != 'd' && thisFormatChar == 'd') {
          // this is the first day character

          if (new RegExp(/[4-9]/g).test(e.key)) {
            textValue =
              textValue.substring(0, textValue.length - 1) + '0' + e.key + '/';
          } else if (!new RegExp(/[0-3]/g).test(e.key)) {
            textValue = textValue.substring(0, textValue.length - 1);
          }
        } else if (thisFormatChar == 'd') {
          // this is the second day char

          if (textValue[textValue.length - 2] == '0') {
            if (!new RegExp(/[1-9]/g).test(e.key)) {
              textValue = textValue.substring(0, textValue.length - 1);
            } else {
              textValue += '/';
            }
          } else if (textValue[textValue.length - 2] == '3') {
            if (!new RegExp(/[0-1]/g).test(e.key)) {
              textValue = textValue.substring(0, textValue.length - 1);
            } else {
              textValue += '/';
            }
          } else {
            textValue += '/';
          }
        } else if (thisFormatChar == 'd') {
          if (guidedFormat[textValue.length] == '/') {
            textValue += '/';
          }
        }
      } else if (textValue.length > textValue.length) {
        // don't allow any more characters
        textValue = textValue.substring(0, guidedFormat.length);
      }
    }

    return textValue;
  }
}
